/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import AssetService from "../../services/AssetService";
import { If } from "../../utils/Controls";
import { AntdPaging, AntdSelect, AntdTag } from "../../utils/Antd";
import util from "../../utils/util";
import * as XLSX from 'xlsx';
import {
    Input,
    Button,
    message,
    Modal,
    Drawer,
    Upload,
    Table,
    Alert,
    Divider,
    Progress,
} from 'antd';
import {
    ExclamationCircleOutlined,
    UploadOutlined,
    DownloadOutlined,
    InboxOutlined,
} from '@ant-design/icons';
const { confirm } = Modal;
const { Dragger } = Upload;

export default function AssetSubCat(props) {
    const { catId, catDtl, handleClose, forceCall, callback, pageno } = props;

    const [result, setResult] = useState({ data: [], page: {} });
    const sdataRef = useRef({ p: 1, ps: 25, catId });
    const formRef = useRef();
    const importRef = useRef();

    const list = (p, ps) => {
        sdataRef.current.catId = catId;
        sdataRef.current.p = p || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        util.showLoader();
        AssetService.subCats(sdataRef.current).then(({ data }) => {
            setResult(data.result);
            if (p) {
                callback(pageno);
            }
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        })
    }

    const deleteRecord = (id) => {
        message.destroy();
        confirm({
            title: 'Do you Want to delete this sub category?',
            icon: <ExclamationCircleOutlined />,
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                util.showLoader();
                AssetService.deleteSubCat(id).then(({ data }) => {
                    message.success(data.message || 'Deleted');
                    list();
                    callback(pageno);
                }).catch(e => {
                    message.error(e.message);
                }).finally(() => {
                    util.hideLoader();
                })
            },
            onCancel() {
            },
        })
    }

    const downloadTemplate = () => {
        const templateData = [
            ['Sub Category Name'],
            ['Cardiac Care'],
            ['Orthopaedics'],
            ['Radiology'],
        ];
        const worksheet = XLSX.utils.aoa_to_sheet(templateData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'SubCategories');
        worksheet['!cols'] = [{ width: 30 }];
        XLSX.writeFile(workbook, `${catDtl.name.toLowerCase().replace(/\s+/g, '_')}_subcategories_template.xlsx`);
        message.success('Template downloaded');
    };

    useEffect(() => {
        sdataRef.current.k = '';
        list();
    }, [forceCall])

    return (
        <Drawer
            title={<><span className="bold text-info">{catDtl.name}: </span> Sub Categories </>}
            width={900}
            onClose={handleClose}
            open
            bodyStyle={{ paddingBottom: 80 }}
            footer={
                <div className="text-right" >
                    <Button onClick={handleClose} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                </div>
            }
        >
            <div className="tab-content">
                <div className="tab-pane fade1 show active">
                    {result.data.length > 0 &&
                        <div className="text-secondary mb8">
                            Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                        </div>
                    }

                    <div className="d-flex tbl-search-head">
                        <div className="my-auto">
                            <SearchForm dataRef={sdataRef} onSearch={list} />
                        </div>
                        <div className="ml-auto my-auto d-flex" style={{ gap: 8 }}>
                            <Button onClick={downloadTemplate} icon={<DownloadOutlined />}>
                                Template
                            </Button>
                            <Button icon={<UploadOutlined />} onClick={() => importRef.current.openForm()}>
                                Import
                            </Button>
                            <Button type="primary" onClick={() => formRef.current.openForm()}>
                                <i className="fa fa-plus mr5"></i> Add
                            </Button>
                        </div>
                    </div>

                    <If cond={result.data.length}>
                        <div className="table-responsive">
                            <table className="table table-bordered table-md table-striped table-hover m-0">
                                <thead className="thead-light text-uppercase table-text-vmid">
                                    <tr>
                                        <th className="w20">SN</th>
                                        <th>Sub Category Name</th>
                                        <th className="w60">Status</th>
                                        <th className="w70"></th>
                                    </tr>
                                </thead>
                                <tbody className="table-text-top">
                                    {result.data.map((v, i) => (
                                        <tr key={i}>
                                            <td>{result.page.start + i + 1}.</td>
                                            <td>{v.name}</td>
                                            <td className="nowrap">
                                                {v.status ? (<AntdTag type="success">Active</AntdTag>) : (<AntdTag type="danger">Inactive</AntdTag>)}
                                            </td>
                                            <td className="text-center">
                                                <Button.Group size="small">
                                                    <Button type="default" onClick={() => formRef.current.openForm(v)}><i className="fa fa-edit"></i></Button>
                                                    <Button type="default" onClick={() => deleteRecord(v.id)}><i className="fa fa-times-circle font-red"></i></Button>
                                                </Button.Group>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex tbl-foot-bx">
                            <AntdPaging
                                onChange={list}
                                total={result.page.total_records}
                                current={result.page.cur_page}
                                pageSize={sdataRef.current.ps}
                                showSizeChanger
                            />
                        </div>
                    </If>
                    <If cond={!result.data.length}>
                        <div className="no-rec">No record found</div>
                    </If>
                </div>
            </div>

            <AddForm
                ref={formRef}
                callback={list}
                pageno={sdataRef.current.p}
                catId={sdataRef.current.catId}
            />

            <ImportForm
                ref={importRef}
                callback={list}
                catId={catId}
                catName={catDtl.name}
            />
        </Drawer>
    );
}


// ── ImportForm ───────────────────────────────────────────────────────────────

const ImportForm = forwardRef((props, ref) => {
    const { callback, catId, catName } = props;
    const [showForm, setShowForm] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [previewData, setPreviewData] = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [importing, setImporting] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const [importSummary, setImportSummary] = useState(null);

    const resetForm = () => {
        setFileList([]);
        setPreviewData([]);
        setValidationErrors([]);
        setImportProgress(0);
        setImportSummary(null);
    };

    const handleFileUpload = (info) => {
        const { fileList: newFileList } = info;
        setFileList(newFileList.slice(-1));
        const file = newFileList[0]?.originFileObj;
        if (!file) return;
        const name = file.name.toLowerCase();
        if (!name.endsWith('.xlsx') && !name.endsWith('.xls')) {
            message.error('Please upload only Excel files (.xlsx or .xls)');
            setFileList([]);
            return;
        }
        parseExcelFile(file);
    };

    const parseExcelFile = (file) => {
        util.showLoader();
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1,
                    defval: '',
                    blankrows: false,
                });

                const firstRow = jsonData[0];
                const isHeader = firstRow?.length > 0 &&
                    typeof firstRow[0] === 'string' &&
                    (firstRow[0].toLowerCase().includes('name') ||
                     firstRow[0].toLowerCase().includes('sub') ||
                     firstRow[0].toLowerCase().includes('category'));

                const dataRows = isHeader ? jsonData.slice(1) : jsonData;

                if (dataRows.length === 0) {
                    message.error('No data rows found');
                    return;
                }

                const { valid, errors } = processRows(dataRows);
                setPreviewData(valid);
                setValidationErrors(errors);

                if (valid.length > 0) {
                    message.success(`Found ${valid.length} valid sub categories`);
                } else {
                    message.warning('No valid rows found');
                }
            } catch (err) {
                message.error('Failed to parse file: ' + err.message);
            } finally {
                util.hideLoader();
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const processRows = (rows) => {
        const valid = [];
        const errors = [];
        const seen = new Set();

        rows.forEach((row, i) => {
            const name = (row[0] || '').toString().trim();
            const rowNum = i + 1;

            if (!name) {
                errors.push(`Row ${rowNum}: Name is required`);
                return;
            }
            if (name.length > 100) {
                errors.push(`Row ${rowNum}: Name too long (max 100 chars)`);
                return;
            }
            const key = name.toLowerCase();
            if (seen.has(key)) {
                errors.push(`Row ${rowNum}: Duplicate in file — "${name}" skipped`);
                return;
            }
            seen.add(key);

            valid.push({ name, cat_id: catId, status: 1 });
        });

        return { valid, errors };
    };

    const performImport = async () => {
        if (previewData.length === 0) {
            message.error('No valid data to import');
            return;
        }
        setImporting(true);
        setImportProgress(0);
        setImportSummary(null);

        let successCount = 0;
        let skippedCount = 0;
        const errorMessages = [];

        for (let i = 0; i < previewData.length; i++) {
            try {
                const res = await AssetService.saveSubCat(previewData[i]);
                if (res.data?.code === 'SUCCESS' || res.data?.message) {
                    successCount++;
                } else {
                    skippedCount++;
                }
            } catch (e) {
                // Duplicate or server-side validation — count as skipped, not hard error
                const msg = e.response?.data?.message || e.message || '';
                if (/duplicate|already exist/i.test(msg)) {
                    skippedCount++;
                    errorMessages.push(`"${previewData[i].name}" already exists — skipped`);
                } else {
                    errorMessages.push(`Row ${i + 1}: ${msg}`);
                }
            }
            setImportProgress(Math.round(((i + 1) / previewData.length) * 100));
        }

        setImportSummary({ successCount, skippedCount, errorMessages });
        setImporting(false);

        if (successCount > 0) {
            message.success(`${successCount} sub categor${successCount === 1 ? 'y' : 'ies'} imported`);
            callback(1);
        }
        if (skippedCount > 0 && successCount === 0) {
            message.warning(`All rows skipped — likely duplicates`);
        }
    };

    const closeForm = () => {
        setShowForm(false);
        resetForm();
    };

    useImperativeHandle(ref, () => ({
        openForm() {
            resetForm();
            setShowForm(true);
        }
    }));

    const previewColumns = [
        { title: '#', key: 'i', width: 50, render: (_, __, i) => i + 1 },
        { title: 'Sub Category Name', dataIndex: 'name', key: 'name' },
    ];

    return (
        <Modal
            title={`Import Sub Categories — ${catName}`}
            open={showForm}
            onCancel={closeForm}
            width={700}
            footer={[
                <Button key="cancel" onClick={closeForm} disabled={importing}>Cancel</Button>,
                <Button
                    key="import"
                    type="primary"
                    onClick={performImport}
                    disabled={previewData.length === 0 || importing || !!importSummary}
                    loading={importing}
                >
                    {importing
                        ? `Importing… ${importProgress}%`
                        : `Import ${previewData.length} Sub Categories`}
                </Button>
            ]}
        >
            {!importSummary && (
                <>
                    <div style={{ marginBottom: 20 }}>
                        <Dragger
                            fileList={fileList}
                            onChange={handleFileUpload}
                            beforeUpload={() => false}
                            accept=".xlsx,.xls"
                            maxCount={1}
                            disabled={importing}
                        >
                            <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                            <p className="ant-upload-text">Click or drag Excel file to upload</p>
                            <p className="ant-upload-hint">One column: Sub Category Name</p>
                        </Dragger>
                    </div>

                    {importing && (
                        <Progress percent={importProgress} status="active" style={{ marginBottom: 16 }} />
                    )}

                    {validationErrors.length > 0 && (
                        <Alert
                            message={`${validationErrors.length} row(s) skipped`}
                            description={
                                <div style={{ maxHeight: 120, overflowY: 'auto' }}>
                                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                                        {validationErrors.slice(0, 10).map((e, i) => <li key={i}>{e}</li>)}
                                        {validationErrors.length > 10 && <li>…and {validationErrors.length - 10} more</li>}
                                    </ul>
                                </div>
                            }
                            type="warning"
                            showIcon
                            style={{ marginBottom: 16 }}
                        />
                    )}

                    {previewData.length > 0 && (
                        <>
                            <Divider>Preview ({previewData.length} rows)</Divider>
                            <Table
                                columns={previewColumns}
                                dataSource={previewData}
                                rowKey={(_, i) => i}
                                size="small"
                                pagination={{ pageSize: 8, showTotal: t => `${t} items` }}
                                scroll={{ y: 220 }}
                            />
                        </>
                    )}

                    <Alert
                        message="Format"
                        description="Column A = Sub Category Name. Optional header row is auto-detected. Duplicates (both within the file and already in the system) are skipped automatically."
                        type="info"
                        showIcon
                        style={{ marginTop: 16 }}
                    />
                </>
            )}

            {importSummary && (
                <Alert
                    message="Import Complete"
                    description={
                        <div>
                            <p><strong>Imported:</strong> {importSummary.successCount}</p>
                            {importSummary.skippedCount > 0 && (
                                <p><strong>Skipped (duplicates):</strong> {importSummary.skippedCount}</p>
                            )}
                            {importSummary.errorMessages.length > 0 && (
                                <div style={{ maxHeight: 120, overflowY: 'auto', marginTop: 8 }}>
                                    <ul style={{ margin: 0, paddingLeft: 20, color: '#cf1322', fontSize: 12 }}>
                                        {importSummary.errorMessages.map((m, i) => <li key={i}>{m}</li>)}
                                    </ul>
                                </div>
                            )}
                        </div>
                    }
                    type={importSummary.successCount > 0 ? 'success' : 'warning'}
                    showIcon
                />
            )}
        </Modal>
    );
});


// ── SearchForm ───────────────────────────────────────────────────────────────

const SearchForm = (props) => {
    let { dataRef, onSearch } = props;
    let [data, setData] = useState({ ...dataRef.current });
    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    }
    useEffect(() => {
        dataRef.current = { ...data };
    }, [data]);

    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps, k: dataRef.current.k });
    }, [dataRef.current.p, dataRef.current.ps, dataRef.current.k]);

    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                <div>
                    <Input placeholder="Search" allowClear value={data.k} onChange={e => handleChange(e.target.value, 'k')} />
                </div>
                <div>
                    <Button type="primary" icon={<i className="fa fa-search fs13"></i>} onClick={() => onSearch()}></Button>
                </div>
            </div>
        </form>
    )
}


// ── AddForm ──────────────────────────────────────────────────────────────────

const AddForm = forwardRef((props, ref) => {
    let { callback, pageno, catId } = props;
    const [showForm, setShowForm] = useState(false);
    let [data, setData] = useState({ catId: catId });
    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    }
    const save = () => {
        message.destroy();
        util.showLoader();
        AssetService.saveSubCat(data).then(({ data }) => {
            message.success(data.message || 'Saved');
            callback(data.id ? pageno : 1);
            setShowForm(false);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        })
    }
    const closeForm = () => {
        setShowForm(false);
    }

    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            setData(dtl ? { ...dtl, cat_id: catId } : { status: '1', cat_id: catId });
            setShowForm(true);
        }
    }));

    return (
        <Modal
            title={`${data.id ? 'Edit' : 'Add'} Asset Sub Category`}
            open={showForm}
            okText="Save"
            onOk={save}
            onCancel={closeForm}
            destroyOnClose
            maskClosable={false}
            width={400}
        >
            <form onSubmit={e => { e.preventDefault(); save() }} autoComplete="off" spellCheck="false">
                <div className="">
                    <div className="row mingap">
                        <div className="col-md-12 form-group">
                            <label className="req">Sub Category Name</label>
                            <Input value={data.name || ''} onChange={e => handleChange(e.target.value, 'name')} />
                        </div>
                        <div className="col-md-12 form-group">
                            <label className="req">Status</label>
                            <div>
                                <AntdSelect
                                    options={[{ value: '1', label: "Active" }, { value: '0', label: "Inactive" }]}
                                    value={data.status}
                                    onChange={v => { handleChange(v, 'status') }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    )
})